export default "__VITE_ASSET__ReVziDVZ__"